import React from "react";
import TableHeaderContainer from "../../ClinicOverview/components/TableHeaderContainer";
import { SortConfig } from "types/common";
import { TABLE_SUPER_ADMIN_ATHLETES_LIST } from "../../../constants/dashboard";

const TableHeader: React.FC<{
  onClick: (sortBy: string) => void;
  sortConfig: SortConfig;
}> = ({ onClick, sortConfig }) => {
  return (
    <TableHeaderContainer
      headerList={TABLE_SUPER_ADMIN_ATHLETES_LIST}
      onClick={onClick}
      sortConfig={sortConfig}
    />
  );
};

export default TableHeader;
